import { useDispatch, useSelector } from 'react-redux';
import sockerSlice, { notifWsSelector } from 'global/WebSocket/slice';
import { useEffect } from 'react';
import { showGeneralNotification } from 'global/Notification';
import { useNotificationData } from 'lib/entities/notification/useNotificationData';

const PRICE_ALERT_KEY = 'price-alert';

function useNotificationListener(isUserLogin = false) {
  const dispatch = useDispatch();
  const unread = useNotificationData((store) => store.unread);
  const setUnread = useNotificationData((store) => store.setUnread);

  const notification: any = useSelector(notifWsSelector);

  const notificationListener = () => {
    const notif = notification[notification.length - 1];
    // Update unread notification
    setUnread(unread + 1);

    const onClose = () => dispatch(sockerSlice.actions.resetNotification());

    // Show notification on left bottom side
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    showGeneralNotification(notif, onClose);
  };

  const getPriceAlertFromLocalStorage = () => {
    const alertRaw = localStorage?.getItem(PRICE_ALERT_KEY);
    if (alertRaw) {
      try {
        return JSON.parse(alertRaw);
      } catch {
        return false;
      }
    }
    return false;
  };

  useEffect(() => {
    if (!isUserLogin) return;
    if (notification?.length > 0) {
      notificationListener();
    }
  }, [notification?.length, isUserLogin]);

  useEffect(() => {
    if (!isUserLogin) return;
    const alert = getPriceAlertFromLocalStorage();
    if (alert) {
      dispatch(sockerSlice.actions.setAlert(alert));
    }
  }, [isUserLogin]);

  return null;
}

export default useNotificationListener;
